import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ConsultationTypesDataTable {
  constructor() {
    $(document).ready(function() {
      showConsultationTypes();
    });

    $(document).on("turbo:render", function() {
      showConsultationTypes();
    });

    function showConsultationTypes() {
      $('#consultation-types-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#consultation-types-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "active"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
